import { DeletePaidAppointmentAction } from "./appointments.delete.paid.types";

export const deletePaidAppointmentRequestAction = (params: { appointment_id: number }): DeletePaidAppointmentAction => ({ type: 'DELETE_PAID_APPOINTMENT_REQUEST', params })

export const deletePaidAppointmentSuccessAction = (): DeletePaidAppointmentAction => ({ type: 'DELETE_PAID_APPOINTMENT_SUCCESS' })

export const deletePaidAppointmentFailureAction = (error?: any): DeletePaidAppointmentAction => ({ type: 'DELETE_PAID_APPOINTMENT_FAILURE', params: error })